var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKahunIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 135.46667 135.46667",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11850_721)",
    id: "g1108",
    transform: "matrix(4.0514323,0,0,3.9692154,-1.5741328,-1.7279373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1739",
    style: {
      fill: "#5a52c3",
      fillOpacity: 1,
      strokeWidth: 0.703029
    },
    d: "m 17.106905,1.168582 a 16,16 0 0 0 -16.0000003,16 16,16 0 0 0 3.007812,9.277344 c -0.08013,5.29866 -1.964858,6.60904 -1.49414,7.251953 0.373786,0.510524 5.208082,-0.509327 7.9667973,-1.927735 a 16,16 0 0 0 6.519531,1.398438 16,16 0 0 0 16,-16 16,16 0 0 0 -16,-16 z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 17.10928,21.5123 -8.6000501,-8.9817 2.2001501,-2.2977 6.3999,6.6839 6.3952,-6.6839 2.2001,2.2977 z",
    fill: "#ffffff",
    id: "path1104"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5092049,
    y: 21.512199,
    width: 17.1954,
    height: 2.96825,
    fill: "#ffffff",
    id: "rect1106"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKahunIcon);
export default __webpack_public_path__ + "static/media/kahunIcon.66993ecfff92046c15da9fc38de7de8b.svg";
export { ForwardRef as ReactComponent };